import BEMHelper from '@/helpers/bem'
import styles from './styles/Cover.module.scss'
const bem = BEMHelper(styles)

import type { TopicTheme } from './index'

interface Props {
  title: string
  description: string
  topicTheme?: TopicTheme
}

export default function Cover({ title, description, topicTheme }: Props) {
  const { illustration } = topicTheme || {}

  return (
    <header {...bem('')} id="cover">
      <div {...bem('content')}>
        <h1 {...bem('title')}>{title}</h1>
        <p {...bem('description')}>{description}</p>
      </div>

      {illustration?.path && (
        <div {...bem('illustration')}>
          <div {...bem('image')}>
            <picture>
              {illustration.webp && <source srcSet={illustration.webp} type="image/webp" />}
              <source srcSet={illustration.path} type="image/png" />
              <img src={illustration.path} alt="" width={800} height={800 / illustration.aspect} />
            </picture>
          </div>
        </div>
      )}
    </header>
  )
}
